import React from 'react';
import { motion } from 'framer-motion';
import { FlameIcon } from 'lucide-react';
import { Divider } from './ui/Divider';
export function PhrasesSection() {
  const phrases = ['Un mal corte no solo cambia cómo te ves. Cambia cómo te mueves durante toda la semana.', 'Pasas horas en el gym construyendo al hombre. Pasa 45 minutos dejándonos enmarcarlo.', 'El barbero correcto no es un lujo. Es una necesidad.', 'Deja de dar propina por lo mediocre. Empieza a invertir en lo excepcional.', 'Tu cabello está hablando. Asegúrate de que esté diciendo lo correcto.', 'El hombre que se ve afilado piensa afilado. Actúa afilado. Gana afilado.', 'Hay una versión de ti que entra a cada cuarto como dueño. Empieza en nuestra silla.', 'Lo suficiente dejó de ser suficiente el día que empezaste a tomarte en serio.', 'Cada hombre elegante en Lehigh Acres sabe algo que el resto todavía no ha descubierto.', 'El espejo no miente. Asegúrate de que te guste lo que te está mostrando.'];
  return <section className="bg-delux-bg py-20 px-4 sm:px-6 lg:px-8" data-id="element-217">
      <div className="max-w-5xl mx-auto" data-id="element-218">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-219">
          <FlameIcon className="w-10 h-10 text-delux-gold mx-auto mb-6" data-id="element-220" />
          <h2 className="font-heading text-3xl md:text-4xl text-delux-gold mb-4" data-id="element-221">
            10 Frases Que Golpean Directo Al Pecho
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-222">
          {phrases.map((phrase, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="bg-delux-card p-6 rounded border border-delux-gold/10 hover:border-delux-gold/40 transition-colors flex items-start" data-id="element-223">
              <span className="font-heading text-2xl text-delux-gold/50 mr-4 font-bold" data-id="element-224">
                {(index + 1).toString().padStart(2, '0')}
              </span>
              <p className="font-body text-delux-white text-lg italic leading-relaxed" data-id="element-225">
                "{phrase}"
              </p>
            </motion.div>)}
        </div>
      </div>
      <Divider data-id="element-226" />
    </section>;
}